import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../../components/shared/context';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {withRouter} from 'react-router-dom'

import UseStyles from '../useStyles';
import TipoPerfil from "../../../constants/tipoPerfil";
import {getConselhos} from "../../../services/usuario/ConselhoService";
import {getAnteriores, getProximas} from "../../../services/reuniao/ReuniaoService";
import {useSnackbar} from "notistack";

const dataItens = [
  { valor: '01', nome: 'Janeiro' },
  { valor: '02', nome: 'Fevereiro' },
  { valor: '03', nome: 'Março' },
  { valor: '04', nome: 'Abril' },
  { valor: '05', nome: 'Maio' },
  { valor: '06', nome: 'Junho' },
  { valor: '07', nome: 'Julho' },
  { valor: '08', nome: 'Agosto' },
  { valor: '09', nome: 'Setembro ' },
  { valor: '10', nome: 'Outubro ' },
  { valor: '11', nome: 'Novembro' },
  { valor: '12', nome: 'Dezembro' },
].map((item, key) => (
  <MenuItem value={item.valor} key={key}>{item.nome}</MenuItem>
));

const ReunioesFilter = (props) => {

  const { enqueueSnackbar } = useSnackbar();

  const { setReunioesAnteriores, setProximasReunioes } = props;

  const classes = UseStyles();

  const [filtro, setFiltro] = useState({ periodicidade: '', idConselho: '', data: '', ano: '', dataInicio: '', dataFim: '' });

  const [conselhos, setConselhos] = useState([]);

  const [anos, setAnos] = useState([]);
  const [useFiltrar, setUseFiltrar] = useState(false);

  useEffect(() => {
    getConselhos().then((response) => setConselhos(response.data));
    getProximasReunioes();
    getReunioesAnteriores();
    ultimosAnos();
  }, [])

  useEffect(() => {
    filtrar();
  }, [useFiltrar])

  const ultimosAnos = () => {
    let anoAtual = new Date().getFullYear();
    let anosL = []
    for (var i = 9; i >= 0; i--) {
     anosL.push(anoAtual-i);
    }
    setAnos(anosL);
  }

  const getProximasReunioes = async () => {
    try {
      const response = await getProximas(filtro);
      const { data } = response;
      setProximasReunioes(data);
    } catch (e) {

    }
  };

  const getReunioesAnteriores = async () => {
    try {
      const response = await getAnteriores(filtro);
      const { data } = response;
      setReunioesAnteriores(data);
    } catch (e) {

    }
  };

  const limparFiltros = () => {
    setFiltro({ periodicidade: '', idConselho: '', data: '', ano: '', dataInicio: '', dataFim: '' });
    setUseFiltrar(!useFiltrar);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFiltro({ ...filtro, [name]: value })
  };

  const filtrar = () => {
    if (filtro.ano && !filtro.data) {
      enqueueSnackbar('Mês não selecionado!', {variant: 'error'});
      return;
    } else if (!filtro.ano && filtro.data) {
      enqueueSnackbar('Ano não selecionado!', {variant: 'error'});
      return;
    } else if (filtro.ano && filtro.data) {
      filtro.dataInicio = filtro.ano + '-' + filtro.data + '-01 00:00:01';
      const dataInicial = new Date( filtro.dataInicio);
      const ultimoDia = new Date(dataInicial.getFullYear(), dataInicial.getMonth() + 1, 0);
      filtro.dataFim = filtro.ano + '-' + filtro.data + '-' + ultimoDia.getDate() + ' 23:59:59';
    }

    getProximasReunioes()
    getReunioesAnteriores();
  }

  const periodicidadeItens =  [
    { valor: 'ORDINARIA', nome: 'Ordinária' },
    { valor: 'EXTRAORDINARIA', nome: 'Extraordinária' }
  ].map((item, key) => (
    <MenuItem value={item.valor} key={key}>{item.nome}</MenuItem>
  ));

  const conselhoItens = conselhos.map((item, key) => (
    <MenuItem value={item.id} key={item.id}>{item.descricao}</MenuItem>
  ));

  const anosItens = anos.map((item, key) => (
    <MenuItem value={item} key={item}>{item}</MenuItem>
  ));


  return (
    <form>
      <div className={classes.barraFiltroDiv}>
        <div className={classes.barraFiltro}>
          <div>
            <Grid container spacing={1}>
              <Grid item md={2} sm={6} xs={12}>
                <Select
                  id="periodicidade"
                  name="periodicidade"
                  variant="outlined"
                  displayEmpty
                  disableUnderline
                  value={filtro.periodicidade}
                  onChange={handleChange}
                  fullWidth
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem style={{ display: 'none' }} value="" disabled>Periodicidade</MenuItem>
                  {periodicidadeItens}
                </Select>
              </Grid>
              <Grid item md={2} sm={4} xs={6}>
                <Select
                  id="idConselho"
                  name="idConselho"
                  disableUnderline
                  displayEmpty
                  variant="outlined"
                  value={filtro.idConselho}
                  onChange={handleChange}
                  fullWidth
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem style={{ display: 'none' }} value="" disabled>Conselho/comissão/comitê</MenuItem>
                  {conselhoItens}
                </Select>
              </Grid>
              <Grid item md={2} sm={1} xs={6}>
                <Select
                  id="data"
                  name="data"
                  variant="outlined"
                  value={filtro.data}
                  onChange={handleChange}
                  fullWidth
                  displayEmpty
                  disableUnderline
                  placeholder="Entidade"
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem style={{ display: 'none' }} value="" disabled>Mês</MenuItem>
                  {dataItens}
                </Select>
              </Grid>
              <Grid item md={2} sm={1} xs={6}>
                <Select
                  id="ano"
                  name="ano"
                  variant="outlined"
                  value={filtro.ano}
                  onChange={handleChange}
                  fullWidth
                  displayEmpty
                  disableUnderline
                  placeholder="Anos"
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem style={{ display: 'none' }} value="" disabled>Ano</MenuItem>
                  {anosItens}
                </Select>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <Button fullWidth variant="contained" className={classes.botaoFiltrar} onClick={filtrar}>
                  Aplicar filtro
                </Button>
              </Grid>
              {(filtro.entidade !== '' || filtro.nome !== '' || filtro.perfil !== '') && (
                <Grid item sm={6} md={2} xs={6}>
                  <Button fullWidth variant="outlined" onClick={limparFiltros}>Limpar filtros </Button>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
      </div>
    </form>
  );
}

export default withRouter(ReunioesFilter);
